module.exports = __webpack_public_path__ + "img/lock grn.fee60996.svg";